import getPropFromModule from './getPropFromModule';

import { FETCHED_DATE } from '../model';

function getMenuFetchedDate(state) {
  const date = getPropFromModule(state, FETCHED_DATE);
  return date ? new Date(date) : null;
}

export default getMenuFetchedDate;
